<template>
  <button v-show="isShowDownload" class="flex flex-center let-download" @click="handleClick">
    <Icon path="preview" name="download" />
  </button>
</template>

<script>
import Icon from '@/components/icon'

export default {
  name: 'Download',
  components: {
    Icon
  },
  props: {
    file: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isShowDownload() {
      return this.file ? this.file.downloadable : true
    }
  },
  methods: {
    handleClick() {
      const { shareId } = this.$route.params
      const downloadURL = `/na-api/shares/${shareId}/files/${this.file.id}/original/?filename=${this.file.name}`

      this.handlDownload(downloadURL)
    },
    handlDownload(downloadURL) {
      const a = document.createElement('a')

      a.download = this.file.name
      a.href = downloadURL
      document.body.appendChild(a)
      a.click()

      setTimeout(() => {
        document.body.removeChild(a)
      }, 60 * 1000)
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('~@/styles/var.less');
  .let-download {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    width: 46px;
    height: 40px;
    border-radius: 13px;
    cursor: pointer;
    user-select: none;
    background: transparent;
    transition: all linear .2s;
    &:hover {
      background-color: rgba(146, 159, 183, 0.5);
    }
    .i-icon-download {
      font-size: 22px;
    }
  }

  @media screen and (max-width: 768px) {
    .let-download {
      width: 26px;
      margin: 0 8px;
      &:hover {
        background-color: transparent;
      }
    }
  }
</style>